module.exports = __webpack_public_path__ + "img/close.38657744.svg";